import SideMenu from './SideMenuView'
export default SideMenu
